import React from "react";

// Hand-drawn rings, the way Teya circles its script accents.
const SINGLE =
  "M41.5 12.5C22 15 7.5 27.5 5.5 45c-2 18.5 17 35.5 46.5 42 34 7.5 85 6 116-4.5 20-7 29.5-20.5 27-35.5-3-17.5-27-30.5-62-36.5-29-5-65-4-89 1.5-11 2.5-22 7.5-29.5 15";

// Two loose overlapping loops, like a marker circled twice.
const DOUBLE_A =
  "M30 44C36 21 96 7 150 11c37 3 47 20 40 40-8 24-66 41-119 37C33 85 13 68 21 46c3-9 11-17 23-24";
const DOUBLE_B =
  "M25 38C39 16 104 4 158 13c36 6 45 27 33 45-16 24-78 37-129 29C27 81 9 60 23 39c6-9 16-16 29-21";

export const Script = ({
  children,
  ring = true,
  variant = "single",
  color = "currentColor",
  width = 1.7,
  className = "",
  ringClassName = "",
}) => (
  <span className={`script relative inline-block ${className}`}>
    <span className="relative">{children}</span>
    {ring && (
      <svg
        aria-hidden="true"
        viewBox="0 0 200 100"
        preserveAspectRatio="none"
        fill="none"
        className={`absolute pointer-events-none ${
          variant === "double" ? "left-[-15%] top-[-56%] w-[130%] h-[212%]" : "left-[-10%] top-[-19%] w-[120%] h-[140%]"
        } ${ringClassName}`}
      >
        {(variant === "double" ? [DOUBLE_A, DOUBLE_B] : [SINGLE]).map((d, i) => (
          <path
            key={i}
            d={d}
            stroke={color}
            strokeWidth={width}
            strokeLinecap="round"
            vectorEffect="non-scaling-stroke"
            opacity={variant === "double" ? 0.95 : 0.9}
          />
        ))}
      </svg>
    )}
  </span>
);

export default Script;
